import mutationsTypes from '@/vuex/tramitacoes/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_LISTA_TRAMITACOES: 'GET_LISTA_TRAMITACOES',
  GET_LISTA_FLUXOS: 'GET_LISTA_FLUXOS',
  GET_LISTA_FLUXOS_REENCAMINHAMENTO: 'GET_LISTA_FLUXOS_REENCAMINHAMENTO',
  GET_LISTA_DESTINOS_FLUXO: 'GET_LISTA_DESTINOS_FLUXO',
  GET_VALIDACAO_FLUXO: 'GET_VALIDACAO_FLUXO',
  GET_DESPACHO_SALVO: 'GET_DESPACHO_SALVO',
  SALVAR_DESPACHO_TRAMITACAO: 'SALVAR_DESPACHO_TRAMITACAO',
  ENVIAR_TRAMITACAO: 'ENVIAR_TRAMITACAO',
  ENVIAR_TRAMITACAO_MULTIPLA: 'ENVIAR_TRAMITACAO_MULTIPLA',
  CONFIRMAR: 'ui/CONFIRMAR',
  GET_LISTA_HIPOTESE_LEGAL: 'GET_LISTA_HIPOTESE_LEGAL',
  SALVAR_DESPACHO_PREPARATORIO: 'SALVAR_DESPACHO_PREPARATORIO'
}

export default types
